import React from 'react';
import Slider from "react-slick";
import { Cinema } from 'api/cinemaClub';
import { useScreenSize } from 'common';

interface CinemaDetailsProps {
    cinemaItem: Cinema;
}

export const CinemaImagesCarousel: React.FC<CinemaDetailsProps> = ({ cinemaItem }) => {
    const { isDesktopSize } = useScreenSize();

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 2000 
    };

    return (
        <div style={{margin: isDesktopSize ? '0 50px 50px 10px' : '0px 20px 40px'}}>
            <Slider {...settings}>
                {cinemaItem.images.map((image, index) => (
                    <div key={index}>
                        <img src={image.photo} alt={`Slide ${index + 1}`} style={{ width: 'auto', height: '400px', margin: 'auto' }} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};